import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/common/Home'
import Login from '@/views/login/index'
import Password from '@/views/password/index'
import ForgetWord from '@/views/forgetPassWord/index'
import ChangeUserName from '@/views/changeUserName/index'
import BusinessHome from '@/views/businessHome/index'
import SettingHome from '@/views/siteSetting/settingHome'

import ClientUsers from '@/views/siteSetting/clientUsers'
import KpTMember from '@/views/siteSetting/kpTMember'
import ClientRoles from '@/views/siteSetting/clientRoles'
import KpUserRole from '@/views/siteSetting/kpUserRole'
import General from '@/views/siteSetting/general/index'
import clientDownloadFileTracking from '@/views/siteSetting/clientDownloadFileTracking/index'
import AuditTrail from '@/views/system/audit-trail'
import CompUserRole from '@/views/siteSetting/componentUserRoles'
import CompTeamMember from '@/views/siteSetting/componentTeamMembers'

import ClientView from '@/views/client-view/home/index'
import Insight from '@/views/client-view/insights'
import KeeCourses from '@/views/client-view/keeCourses'
import GroupReporting from '@/views/client-view/groupReporting'
import PBCManage from '@/views/client-view/pbc-management'
import ClientAdmin from '@/views/client-view/client-admin'
import NewPbc from '@/views/client-view/pbc-management/pbc-list'
import MatterLogs from '@/views/client-view/matter-logs'
import SAS from '@/views/client-view/SAS'
import Exchange from '@/views/client-view/exchange'
import ITADetail from '@/views/client-view/exchange/ITA/detail'
import Confirmation from '@/views/client-view/confirmation'

import System from '@/views/system'
import User from '@/views/system/user'
import SysAdmin from '@/views/system/system-admin'
import SecurotyAuditor from '@/views/system/security-auditor'
import Site from '@/views/system/site/index'
import newsManagement from '@/views/system/news-management/index'

import MasterData from '@/views/system/master-data/index'

import AutoFetch from '@/views/fetch-user'

import Error403 from '@/views/error/403'
import ErrorNotRole from '@/views/error/notRole'
import ErrorNotSite from '@/views/error/notSite'

import ToNextYear from '@/views/siteSetting/toNextYear/index'
import Error404 from '@/views/error/404'
import InternError from '@/views/internError'
import Faq from '@/components/common/Faq'
import CourseListNew from '@/views/client-view/keeCourses/courseListNew.vue'
import NewKeeWrap from '@/views/new-kee-wrap'
import confirmationGuide from '@/views/client-view/confirmation/Components/ConfirmationGuide'

Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

// add 新路由之后 要到 tags.vue文件添加配置以确保 面包屑显示正常
const router = new Router({
    routes: [
        {
            path: '/confirmation-guide',
            name: 'confirmationGuide',
            component: confirmationGuide,
        },
        {
            path: '/newKee',
            name: 'newKee',
            component: NewKeeWrap,
            redirect: '/newKee/keeList',
            meta: { title: 'kee_course_column' },
            children: [
                {
                    path: '/newKee/keeList',
                    name: 'keeListNew',
                    component: CourseListNew,
                    meta: { title: 'kee_course_column' },
                },
                {
                    path: '/newKee/myCourse',
                    component: () => import('@/views/client-view/keeCourses/myCourseNew'),
                    name: 'myCourseNew',
                    meta: { title: 'kee_my' },
                },
                {
                    path: '/newKee/courseDetail',
                    component: () => import('@/views/client-view/keeCourses/courseDetailNew'),
                    name: 'courseDetailNew',
                    meta: { title: 'kee_detail' }
                },
            ]
        },
        {
            path: '/autoFetch',
            name: 'autoFetch',
            component: AutoFetch
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: ClientView
        },
        {
            path: '/',
            component: Home,
            name: 'home',
            //redirect: '/businessHome',
            meta: { title: '' },
            children: [
                {
                    path: '/client',
                    component: ClientView,
                    name: 'client',
                    meta: { title: 'client000' }
                },
                {
                    path: '/insights',
                    component: KeeCourses,
                    name: 'insights',
                    meta: { title: 'client004' }
                },
                {
                    path: '/group',
                    component: GroupReporting,
                    name: 'group',
                    meta: { title: 'client007' }
                },
                {
                    path: '/exchange',
                    component: Exchange,
                    name: 'exchange',
                    meta: { title: 'client005' }
                },
                {
                    path: '/ita',
                    component: ITADetail,
                    name: 'ita',
                    meta: { title: 'client005_2' }
                },
                {
                    path: '/confirmation',
                    component: Confirmation,
                    name: 'confirmation',
                    meta: { title: 'client006' }
                },
                {
                    path: '/pbc',
                    component: PBCManage,
                    name: 'pbc',
                    meta: { title: 'client001' }
                },
                {
                    path: '/admin',
                    component: ClientAdmin,
                    name: 'admin',
                    meta: { title: 'client008' }
                },
                {
                    path: '/new-pbc-list',
                    component: NewPbc,
                    name: 'newPbcList',
                    meta: { title: 'COMMON_PBC_LIST' }
                },
                {
                    path: '/courseList',
                    component: () => import('@/views/client-view/keeCourses/courseList'),
                    name: 'courseList',
                    meta: { title: 'courseList' }
                },
                {
                    path: '/csConsult',
                    component: () => import('@/views/client-view/keeCourses/csConsult'),
                    name: 'csConsult',
                    meta: { title: 'csConsult' }
                },
                {
                    path: '/myCourse',
                    component: () => import('@/views/client-view/keeCourses/myCourse'),
                    name: 'myCourse',
                    meta: { title: 'myCourse' }
                },
                {
                    path: '/courseDetail',
                    component: () => import('@/views/client-view/keeCourses/courseDetail'),
                    name: 'courseDetail',
                    meta: { title: 'courseDetail' }
                },
                {
                    path: '/accounts',
                    component: SAS,
                    name: 'accounts',
                    meta: { title: 'client002' }
                },
                {
                    path: '/matterLogs',
                    component: MatterLogs,
                    name: 'matterLogs',
                    meta: { title: 'client003' }
                },
                {
                    path: '/system',
                    component: System,
                    name: 'system',
                    meta: { title: 'system000' }
                },
                {
                    path: '/user',
                    component: User,
                    name: 'user',
                    meta: { title: 'system001' }
                },
                {
                    path: '/sysAdmin',
                    component: SysAdmin,
                    name: 'sysAdmin',
                    meta: { title: 'system002' }
                },
                {
                    path: '/securityAuditor',
                    component: SecurotyAuditor,
                    name: 'securityAuditor',
                    meta: { title: 'system006' }
                },
                {
                    path: '/news',
                    component: newsManagement,
                    name: 'news',
                    meta: { title: 'system007' }
                },
                {
                    path: '/site',
                    component: Site,
                    name: 'site',
                    meta: { title: 'system003' }
                },
                {
                    path: '/masterData',
                    name: 'masterData',
                    component: MasterData,
                    meta: { title: 'system004' }
                },
                {
                    path: '/auditTrail',
                    name: 'auditTrail',
                    component: AuditTrail,
                    meta: { title: 'system005' }
                },
                {
                    path: 'clientUsers',
                    component: ClientUsers,
                    name: 'clientUsers',
                    meta: { title: 'site003' }
                },
                {
                    path: 'settingHome',
                    component: SettingHome,
                    name: 'settingHome',
                    meta: { title: 'site000' }
                },
                {
                    path: 'kpmgTeamMember',
                    component: KpTMember,
                    name: 'kpmgTeamMember',
                    meta: { title: 'site005' }
                },
                {
                    path: 'clientRoles',
                    component: ClientRoles,
                    name: 'clientRoles',
                    meta: { title: 'site002' }
                },
                {
                    path: 'kpUserRole',
                    component: KpUserRole,
                    name: 'kpUserRole',
                    meta: { title: 'site004' }
                },
                {
                    path: 'general',
                    component: General,
                    name: 'general',
                    meta: { title: 'site001' }
                },
                {
                    path: 'toNextYear',
                    component: ToNextYear,
                    name: 'toNextYear',
                    meta: { title: 'site006' }
                },
                {
                    path: 'clientDownloaded',
                    component: clientDownloadFileTracking,
                    name: 'clientDownloaded',
                    meta: { title: 'site007' }
                },
                {
                    path: '/groupReportingRole',
                    name: 'groupReportingRole',
                    component: CompUserRole,
                    meta: { title: 'site008' }
                },
                {
                    path: '/groupReportingUser',
                    name: 'groupReportingUser',
                    component: CompTeamMember,
                    meta: { title: 'site009' }
                }
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/changePassword',
            name: 'changePassword',
            component: Password
        },
        {
            path: '/forgetPassword',
            name: 'forgetPassword',
            component: ForgetWord
        },
        {
            path: '/changeUserName',
            component: ChangeUserName
        },
        {
            path: '/businessHome',
            name: 'businessHome',
            component: BusinessHome
        },
        {
            path: '/faq',
            name: 'faq',
            component: Faq
        },
        {
            path: '/403',
            name: '403',
            component: Error403
        },
        {
            path: '/notRole',
            name: 'notRole',
            component: ErrorNotRole
        },
        {
            path: '/notSite',
            name: 'notSite',
            component: ErrorNotSite
        },
        {
            path: '/internError',
            name: 'internError',
            component: InternError
        },
        {
            path: '*',
            name: '404',
            component: Error404
        }
    ]
})

// router.beforeResolve((to, from, next) => {
//     if (to.path === '/new-pbc-list') {
//         if (to.query.audit === '1') {
//             to.meta.title =  `${vm.$t('COMMON_PBC_LIST')} - ${vm.$t('COMMON_INTERIM')}`
//         } else {
//             to.meta.title = `${vm.$t('COMMON_PBC_LIST')} - ${vm.$t('COMMON_FINAL')}`
//         }
//     }
//     next()
// })

export default router
